import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/employee-status-reasons',
    name: 'employee-status-reason',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/employee-status-reason/index.vue')
  }
]
